export const SN_UTIL = "util"
export const UTIL_ENUMS_UPDATED = SN_UTIL + "/ENUMS_UPDATED"
export const UTIL_FACILITIES_UPDATED = SN_UTIL + "/FACILITIES_UPDATED"
export const UTIL_SHIPPING_METHOD_UPDATED = SN_UTIL + "/SHIPPING_METHOD_UPDATED"
export const UTIL_FACILITY_GROUP_UPDATED = SN_UTIL + "/FACILITY_GROUP_UPDATED"
export const UTIL_OMS_CONNECTION_STATUS_UPDATED = SN_UTIL + "/OMS_CONNECTION_STATUS_UPDATED"
export const UTIL_STATUSES_UPDATED = SN_UTIL + "/STATUSES_UPDATED"
export const UTIL_CLEARED = SN_UTIL + "/CLEARED"